// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreProduct = (client) => ({
    /**
     * `GET /store/products/:id/applications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreProductsIdApplicationsRetrieve
     * @source packages/modules/b2c-core/src/api/store/products/[id]/applications/route.ts
     */
    listApplications: (id, query, headers) => client.fetch(buildPath("/store/products/:id/applications", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/products/best-sellers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListBestSellers
     * @source apps/backend/src/api/store/products/best-sellers/route.ts
     */
    listBestSellers: (query, headers) => client.fetch("/store/products/best-sellers", { method: "GET", query, headers }),
    /**
     * `GET /store/products/:id/certifications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListProductCertifications
     * @source packages/medusa-plugin-product-documents/src/api/store/products/[id]/certifications/route.ts
     */
    listCertifications: (id, query, headers) => client.fetch(buildPath("/store/products/:id/certifications", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/products/:id/offers`
     *
     * @operationId StoreProductsIdOffersRetrieve
     * @source packages/modules/b2c-core/src/api/store/products/[id]/offers/route.ts
     */
    listOffers: (id, query, headers) => client.fetch(buildPath("/store/products/:id/offers", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/products/:id/product-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListProductDocuments
     * @source packages/medusa-plugin-product-documents/src/api/store/products/[id]/product-documents/route.ts
     */
    listProductDocuments: (id, query, headers) => client.fetch(buildPath("/store/products/:id/product-documents", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/products/catalog`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreProductsCatalogList
     * @source packages/modules/b2c-core/src/api/store/products/catalog/route.ts
     */
    retrieveCatalog: (query, headers) => client.fetch("/store/products/catalog", { method: "GET", query, headers }),
    /**
     * `GET /store/products/:productId/code-tree`
     *
     * @operationId StoreGetProductCodeTree
     * @source packages/medusa-plugin-product-codes-v2/src/api/store/products/[productId]/code-tree/route.ts
     */
    retrieveCodeTree: (productId, query, headers) => client.fetch(buildPath("/store/products/:productId/code-tree", [productId]), { method: "GET", query, headers }),
    /**
     * `GET /store/products/:id/legal`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreProductsIdLegalRetrieve
     * @source apps/backend/src/api/store/products/[id]/legal/route.ts
     */
    retrieveLegal: (id, query, headers) => client.fetch(buildPath("/store/products/:id/legal", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/products/price-sorted`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreProductsPriceSortedList
     * @source packages/modules/b2c-core/src/api/store/products/price-sorted/route.ts
     */
    retrievePriceSorted: (query, headers) => client.fetch("/store/products/price-sorted", { method: "GET", query, headers }),
    /**
     * `POST /store/products/search`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreProductsSearchCreate
     * @source packages/modules/b2c-core/src/api/store/products/search/route.ts
     */
    search: (body, query, headers) => client.fetch("/store/products/search", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=products.js.map